import { useState, useEffect, useRef, useContext } from "react";
import { Box, Spinner, Text, grommet, Grommet,} from "grommet";
import { useLocation } from "react-router-dom";
import { useFetch } from "use-http";
import { useNavigate } from "react-router-dom";
import { getDBURL, updateStateHandler, calculateHeight, sheetStatus
    , getKeyByValue, correctTimeZone, convertDateToDisplayformat, generateSyncId } from "../components/Utils/Utils";
import { UserContext } from "../App";
import TreatmentDetails from "../components/Treatment/TreatmentDetails";
import HomePageNav from "../components/Base components/HomePageNav";
import SheetHeader from "../components/Base components/SheetHeader";
import Notification from "../components/Base components/Notification";
import WarningPopupWindow from "../components/Base components/WarningPopupWindow";
import { useErrorLogger } from '../components/Base components/Logger';

const TreatmentPage = (props) => {
    const currentUser = useContext(UserContext);
    const { DBlogError } = useErrorLogger();
    const { state } = useLocation();
    // console.log('TreatmentPage state  >>  ', state);    
    const [editMode, setEditMode] = useState(state.editMode);
    const [disable, setDisable] = useState(state.disable);
    const [valuesLoaded, setValuesLoaded] = useState(false);
    const station = state.station;
    const scions = state.scionsList;
    const [loadExisting, setLoadExisting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [navigateAfterSuccess, setNavigateAfterSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState(''); 

    const sheetName = state.sheetName ? state.sheetName : "TREATMENT";
    const showTreatments = state.showTreatments;
    const navigate = useNavigate();

    const existingTreatmentID = state.treatmentID;
    //  const [existingTreatmentID, setExistingTreatmentID] = useState(state.treatmentID);
    // console.log('state.treatmentID >> ', state.treatmentID);
    const newTreatment = useRef(state.treatmentID === null);
    const [hasEdit, setHasEdit] = useState(false);
    // const isInitialMount = useRef(true); // Flag to check if it's the first render

    const { get, post } = useFetch(getDBURL());
    const [templatesComboList, setTemplatesComboList] = useState([]);
    const [templatesList, setTemplatesList] = useState([]);

    // This template serves as the foundation for creating treatment templates. 
    // If no base template treatment exists, it will be used to create a treatment for the station.
    const [baseTreatment, setBaseTreatment] = useState(""); 
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    //const [defaultName, setDefaultName] = useState(''); 
    

    // console.log('state.disable >> ', state.disable);
    // console.log('disable >> ', disable);
    // console.log('state.station >> ', state.station);

    const getStateValues =  (values) => {
        const isNull = values === null;
        return {
            TreatmentID: isNull && !existingTreatmentID ? generateSyncId() : existingTreatmentID,  
            TreatmentName: isNull ? null : values.TreatmentName,     
            CreateDate: isNull ? correctTimeZone(new Date()) : values.CreateDate,
            CreatedBy: isNull ? currentUser.email : values.CreatedBy,
            Year: isNull ?  new Date().getFullYear() : values.Year,
            StatusID: isNull ? getKeyByValue(sheetStatus,'In Progress') : values.StatusID,
            Notes: isNull ? null : values.Notes,
            ImgExist: isNull ? null : values.ImgExist,            
            UpdatedAt: isNull ? null : values.UpdatedAt,           
            UpdatedBy: isNull ? null : values.UpdatedBy,
            FinishedAt: isNull ? null : values.FinishedAt,
            FinishedBy: isNull ? null : values.FinishedBy, 
            LastSyncDate: correctTimeZone(new Date()),   
        };
    };

    const [treatmentValues, setTreatmentValues] = useState(getStateValues(null));
    const [treatmentValValues, setTreatmentValValues] = useState({});

    useEffect(() => {
        // Reset notifications
        setShowError(false);
        setSuccess(false);
        setNotificationMessage("");
    
        // Function to check if two objects are different
        const haveValuesChanged = (prev, current) => {
            if (prev && Object.keys(prev).length === 0)
                return false;
            return JSON.stringify(prev) !== JSON.stringify(current);
        };

        // Check if treatmentValues or treatmentValValues have changed
        const treatmentValuesChanged = haveValuesChanged(prevTreatmentValues.current, treatmentValues) && (prevTreatmentValues.current.TreatmentName !== null ) ;
        const treatmentValValuesChanged = haveValuesChanged(prevTreatmentValValues.current, treatmentValValues);
    
        // if (!isInitialMount.current && editMode && (treatmentValuesChanged || treatmentValValuesChanged)) {
        if (editMode && (treatmentValuesChanged || treatmentValValuesChanged)) {
            // console.log('Setting hasEdit to true'); // Debugging log
            setHasEdit(true);
        }
    
        // Update previous values
        prevTreatmentValues.current = treatmentValues;
        prevTreatmentValValues.current = treatmentValValues;

    }, [treatmentValues, treatmentValValues]);
    
    // Usage of useRef to store previous values
    const prevTreatmentValues = useRef(treatmentValues);
    const prevTreatmentValValues = useRef(treatmentValValues);

    
    useEffect(() => {
        // console.log('In useEffect hasEdit ==>>  ', hasEdit);    
        if (hasEdit && !newTreatment.current) {
            updateStateHandler(setTreatmentValues, "UpdatedAt", correctTimeZone(new Date()));
            updateStateHandler(setTreatmentValues, "UpdatedBy", currentUser.email);  
            updateStateHandler(setTreatmentValues, "LastSyncDate", correctTimeZone(new Date())); 
        }      
    }, [hasEdit]);

    // console.log(' hasEdit ==>>  ', hasEdit);    
    
    const navigateToEvalSheet = () => {
        setNavigateAfterSuccess(false); // reset flag
        // console.log(' submit  state.plantInfo :  ', state.plantInfo );
        // console.log(' submit   state.selectedField:  ',  state.selectedField);
        // console.log(' submit   station:  ',  station);
        // console.log(' submit   state.station:  ',  state.station);
        navigate('/eval-sheet', { 
            state:{
                fromAnotherScreen: true, 
                chosenOption: "Stations",
                selectedStation: state.station,
                plantInfo: state.plantInfo  === undefined ? null : state.plantInfo ,         // for EvaluationSheet screen 
                activeStationsList: state.activeStationsList,
                chosenVineInfo: state.plantInfo  === undefined ? null : state.plantInfo,    // for ExistingEvaluation screen               
                showScionOnField: (state.plantInfo  === undefined) ? false : true,
                showTreatments: state.showTreatments,
            }  
        });
    };

    useEffect(() => {
        const loadData = async () => {
            if (editMode) {
                setLoadExisting(true);
                await loadTreatmentHandler(); // Ensure this is awaited if it returns a promise
            } else {
                await loadDefaultTreatments(); // Ensure this is awaited if it returns a promise
                setValuesLoaded(true);
                setLoadExisting(false);            
            }
        };
    
        loadData();
    }, []); 


    async function loadTreatmentHandler() {
        try {
            // console.log('In loadTreatmentHandler existingTreatmentID >> ', existingTreatmentID);
            const response = await get("/loadTreatment/treatmentID=" + existingTreatmentID + "/dt=" + Date.now())

            // Check if the response is successful
            if (!response.success) {
                //console.log("In loadTreatmentHandler response   >> ", response.message); 
                throw new Error(`HTTP error! ${response.message}`);
            }

            const data = response.result;
            if( data && data.length > 0) {
                // console.log("loaded treatment values:", data[0]);
                setTreatmentValues(getStateValues(data[0]));
                if(editMode && !valuesLoaded) {
                    await loadTreatmentValHandler()
                    // setHasEdit(false);
                }
                else {
                    await loadDefaultTreatments();
                }

                setValuesLoaded(true);
            }
        
         }
        catch (error) {
            console.error('Error in f-n loadTreatmentHandler ', error.message);

            // Log the error
            await DBlogError({
                error: error,
                parameters: JSON.stringify({ existingTreatmentID }),
                userName: currentUser.email,
                moduleName: 'TreatmentsPage',
                functionName: 'loadTreatmentHandler',
                description:  'Error occurred in loadTreatmentHandler function'
            });
        }
    }

    const loadDefaultTreatments = async () => {
        try {
            const response = await get("/loadDefaultTreatments/dt=" + Date.now());
    
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }

            const res = response.result;
            if (res && res.length > 0) {
                // console.log('res[0] >> ', res[0]);

                let templatesListForCombo = [];
                let defaultTreatmentId = "";  // Initialize to null to hold the default treatment object
                let defaultTreatmentObject;
                let treatmentValuesMap = new Map();  // Initialize a map to group by TreatmentID
    
                res[0].forEach(item => {
    
                    // Prevent duplicate entries in templatesListForCombo and skip IsDefault === 1 items
                    const exists = templatesListForCombo.some(treatment => treatment.TreatmentID === item.DefTreatmentId);
                    if (!exists && item.IsDefault !== 1) {
                        templatesListForCombo.push({
                            TreatmentID: item.DefTreatmentId,
                            TreatmentName: item.TreatmentName,
                            Priority: item.Priority
                        });
                    }

                    // Group items by TreatmentID
                    if (!treatmentValuesMap.has(item.DefTreatmentId)) {
                        treatmentValuesMap.set(item.DefTreatmentId, {
                            TreatmentID: item.DefTreatmentId,
                            TreatmentName: item.TreatmentName,
                            Priority: item.Priority,
                            CreateDate: item.CreateDate, 
                            CreatedBy: item.CreatedBy,                               
                            UpdatedAt: item.UpdatedAt,
                            UpdatedBy: item.UpdatedBy,
                            values: []
                        });
                    }
    
                    // Add values to the grouped TreatmentID
                    treatmentValuesMap.get(item.DefTreatmentId).values.push({
                        TreatmentValueID: item.Id,
                        LabelName: item.LabelName,
                        PhenologicalStageNum: item.PhenologicalStage,
                        Product: item.Product,
                        Dose: item.Dose,
                        OrderBy: item.OrderBy,
                        IsDefaultField: item.IsDefaultField,
                    });

                    // If the treatment is the default one, store its ID for later use
                    if (item.IsDefault === 1) {
                        defaultTreatmentId = item.DefTreatmentId;
                    }

                });
    
                // Set the baseTreatment state to the full default treatment object if it exists
                if (defaultTreatmentId !== "") {
                    defaultTreatmentObject = treatmentValuesMap.get(defaultTreatmentId);
                    setBaseTreatment(defaultTreatmentObject);
                    // console.log('Template Treatment >> ', defaultTreatmentObject);
                }

                // Sort templatesListForCombo by Priority
                templatesListForCombo = templatesListForCombo.sort((a, b) => a.Priority - b.Priority);
                // console.log('Treatment combo list >> ', templatesListForCombo);

                const firstTreatment = templatesListForCombo.length > 0 
                    ? treatmentValuesMap.get(templatesListForCombo[0].TreatmentID) 
                    : defaultTreatmentObject;

                // Create treatmentValValues from the first treatment, only including items where IsDefaultField === 1
                setTreatmentValValues(prevValues => {
                    const newValues = [];

                    firstTreatment.values.forEach(dataValue => {
                        if (dataValue.IsDefaultField === 1) {
                            newValues.push({
                                TreatmentValueID: generateSyncId(),
                                TreatmentID: treatmentValues.TreatmentID,
                                LabelName: dataValue.LabelName,
                                PhenologicalStageNum: dataValue.PhenologicalStageNum,
                                Date: null,
                                Product: dataValue.Product,
                                Dose: dataValue.Dose,
                                OrderBy: dataValue.OrderBy,
                                LastSyncDate: correctTimeZone(new Date()),
                            });
                        }
                    });
                    return newValues;
                });

                updateStateHandler(setTreatmentValues, "TreatmentName", 
                    firstTreatment.TreatmentID === defaultTreatmentObject.TreatmentID ? '' :   firstTreatment.TreatmentName);


                // Set selected template
                setSelectedTemplate(firstTreatment);

                // Convert the map to an array and update the state
                setTemplatesList(Array.from(treatmentValuesMap.values()));
    
                // Store the treatment combo list in the state
                setTemplatesComboList(templatesListForCombo);
                setValuesLoaded(true);
                setEditMode(true);
               
            } else {
                console.warn('No data received for default treatments.');
            }
    
        } catch (error) {
            console.error('Error in function loadDefaultTreatments', error.message);
    
            // Log the error
            await DBlogError({
                error: error,
                parameters: { docType: 'defaultTreatment' },
                userName: currentUser.email,
                moduleName: 'TemplateTreatmentsPage',
                functionName: 'loadDefaultTreatments',
            });
        }
    };

    
    const onChangeSelected = (template) => {
        // If the selected template is the same as the current one, no need to proceed
        if (template && selectedTemplate.TreatmentID === template.TreatmentID) return;
    
        // Determine if we're using the base treatment or a found template
        const templateToUse = template && templatesList && templatesList.length > 0 
            ? templatesList.find(item => item.TreatmentID === template.TreatmentID) 
            : baseTreatment;
    
        if (!templateToUse) {
            console.warn("The selected treatment was not found, so the base treatment will be used instead.");
            return;
        }
    
        // Update specific properties in the template's values, only including items where IsDefaultField === 1
        const updatedValues = templateToUse.values
            .filter(value => value.IsDefaultField === 1)  // Only include items marked as default
            .map(value => ({
                ...value,
                TreatmentValueID: generateSyncId(),       // Generate a new ID for each value
                TreatmentID: treatmentValues.TreatmentID, // Use the correct TreatmentID from the selected template
                Date: null,                               // Reset the date to null
                LastSyncDate: correctTimeZone(new Date()),// Update the sync date to the current time
            }));
    
        // Update the state with the modified values
        setSelectedTemplate(templateToUse);
    
        setTreatmentValues(prevState => ({
            ...prevState,
            TreatmentName: templateToUse.TreatmentID === baseTreatment.TreatmentID ? '' : templateToUse.TreatmentName // Update the treatment name
        }));
    
        setTreatmentValValues(updatedValues);
    };
    

    // from page 2    
    async function loadTreatmentValHandler() {
        try {
            const response = await get(`/loadTreatmentValue/treatmentID=${treatmentValues.TreatmentID}/dt=${Date.now()}`);
            // console.log("In addNewTreatmentScion treatmentValues.TreatmentID  -------->> ", treatmentValues.TreatmentID); 
            // Check if the response is successful
            if (!response.success) {
                // console.log("In addNewTreatmentScion response   >> ", response.message); 
                throw new Error(`HTTP error! ${response.message}`);
            }
            const data = response.result;

            if (data && data.length > 0) {

                   // Update treatmentValValues
                   setTreatmentValValues(prevValues => {
                    const newValues = [];

                    // Add new treatment values
                    data.forEach(dataValue => {
                        newValues.push({
                            TreatmentValueID: dataValue.TreatmentValueId,
                            TreatmentID: dataValue.TreatmentId,
                            LabelName: dataValue.LabelName,
                            PhenologicalStageNum: dataValue.PhenologicalStage,
                            Date: dataValue.Date,
                            Product: dataValue.Product,
                            Dose: dataValue.Dose,
                            OrderBy: dataValue.OrderBy,
                            LastSyncDate: dataValue.LastSyncDate,
                        });
                    });
                    return newValues;
                });
            }
        } catch (error) {
            console.error('Error in loadTreatmentValHandler:', error);

            // Log the error
            await DBlogError({
                error: error,
                parameters: JSON.stringify({ treatmentID: treatmentValues.TreatmentID }),
                userName: currentUser.email,
                moduleName: 'TreatmentsPage',
                functionName: 'loadTreatmentValHandler',
                description:  'Error occurred in loadTreatmentValHandler function'
            });
        }
    }        

    /*  Runs when creating new treatment
    Inserts one row per scion into the VEM_Treatment_Scion table **/
    async function addNewTreatmentScion(treatment) {
        try {
            let values = []; 
            scions.map((item) => 
            { 
                const ts =  
                {  
                    Id: generateSyncId(),
                    TreatmentID: treatment.TreatmentID,
                    ScionID: item.Id,
                    CreateDate: correctTimeZone(new Date()),
                    CreatedBy: currentUser.email,
                    FinishedAt: treatment.StatusID === 5 ? correctTimeZone(new Date()) : null,
                    FinishedBy: treatment.StatusID === 5 ? currentUser.email : null,
                    LastSyncDate: correctTimeZone(new Date()), 
                }
                values = values.concat(ts); 
            })
            // console.log('!!!!!    values before insert to TreatmentScions >> ', values)
            const response = await post('/insertTreatmentScions', values);

            // Check if the response is successful
            if (!response.success) {
                // console.log("In addNewTreatmentScion response   >> ", response.message); 
                throw new Error(`HTTP error! ${response.message}`);
            }       
        }
        catch (error) {
            console.error('Error in f-n addNewTreatmentScion ', error.message);
            
            // Log the error
            await DBlogError({
                error: error,
                parameters: JSON.stringify({ treatment, scions }),
                userName: currentUser.email,
                moduleName: 'TreatmentsPage',
                functionName: 'addNewTreatmentScion',
                description:  'Error occurred in addNewTreatmentScion function'
            });
        }
    }

    async function saveTreatmentHandler() {
        // console.log(' In saveTreatmentHandler !! level 1');
        // console.log("In saveTreatmentHandler treatmentValues   >> ", treatmentValues);

        // create or update depending on edit mode:
        if (editMode && !newTreatment.current) {
            try {
                const response = await post("/updateTreatment", treatmentValues);

                // Check if the response is successful
                if (!response.success) {
                    // console.log("In saveTreatmentHandler response   >> ", response.message); 
                    throw new Error(`HTTP error! ${response.message}`);
                }  
                await saveTreatmentValues();
                setHasEdit(false);
                return true;
            }
            catch(error)
            {
                console.error('Error In saveTreatmentHandler f-n on update: ', error.message);
                setShowError(true);
                setNotificationMessage(error.message);

                // Log the error
                await DBlogError({
                    error: error,
                    parameters: JSON.stringify(treatmentValues),
                    userName: currentUser.email,
                    moduleName: 'TreatmentsPage',
                    functionName: 'saveTreatmentHandler',
                    description:  'Error in saveTreatmentHandler function at update treatment, in \'if\' part when editMode === true and changeCount.current = 4'
                });

                return false;
            };         
        } else {
            try {
                let response = await post("/createTreatment", treatmentValues); 
                
                // Check if the response is successful
                if (!response.success) {
                    // console.log("In addNewTreatment response   >> ", response.message); 
                    throw new Error(`HTTP error! ${response.message}`);
                }  

                // console.log('In if newTreatmentId >> ', newTreatmentId);
                await addNewTreatmentScion (treatmentValues);
                await saveTreatmentValues();
                setHasEdit(false);
                newTreatment.current = false;
                return true;
             
            }
            catch (error) {
                console.error('Error In saveTreatmentHandler f-n on create: ', error.message);
                setShowError(true);
                setNotificationMessage(error.message);

                // Log the error
                await DBlogError({
                    error: error,
                    parameters: JSON.stringify(treatmentValues),
                    userName: currentUser.email,
                    moduleName: 'TreatmentsPage',
                    functionName: 'saveTreatmentHandler',
                    description:  'Error in saveTreatmentHandler function at create treatment, in \'else\' part when changeCount.current = 2'
                });

                return false;
            }
        }
    }


        // for page 2
        // saving treatmentTable values
        // updateTreatmentValue inserts into table 
        // or updates table VEM_TreatmentValues
        async function saveTreatmentValues() {
            try {
                // console.log('In saveTreatmentValues treatmentValValues >> ', treatmentValValues);
                const response = await post("/updateTreatmentValue", treatmentValValues)

                // Check if the response is successful
                if (!response.success) {
                    // console.log("In addNewTreatmentScion response   >> ", response.message); 
                    throw new Error(`HTTP error! ${response.message}`);
                } 

                if (response.result) {                   
                    setValuesLoaded(true);
                    setEditMode(true);
                    setSuccess(true);
                    setNotificationMessage(sheetName + " sheet created successfully.");
                    setHasEdit(false);              
                    return true;
                }
            }
            catch (error) {
                console.error('Error In saveTreatmentValues f-n: ', error.message);
                setShowError(true);
                setNotificationMessage(error.message); 

                // Log the error
                await DBlogError({
                    error: error,
                    parameters: JSON.stringify(treatmentValValues),
                    userName: currentUser.email,
                    moduleName: 'TreatmentsPage',
                    functionName: 'saveTreatmentValues',
                    description:  'Error in saveTreatmentValues function'
                });          
                return false;
            }
        }        

    // console.log('treatmentValValues >> ', treatmentValValues);


    // hides the "Warning" popup window 
    const onClose = () => {
        setWarningMessage('');
        setShowWarning(false);
    };    


    return (
        <Box fill>
            <Box
                style={{ 
                    position: 'fixed',
                    top: 0,
                    zIndex: 10,
                    height: calculateHeight(5)
                }}>                
                <HomePageNav 
                    selectedField={state.selectedField}
                    station={state.station}
                    plantInfo={state.plantInfo === undefined ? null : state.plantInfo} 
                    activeStationsList={state.activeStationsList}            
                    hasEdit={hasEdit} 
                    save={saveTreatmentHandler}
                    isDefault={false}
                    showTreatments={state.showTreatments}
                    showTreatmentsMultiYearSummary={state.showTreatmentsMultiYearSummary}   
                />
            </Box>
            
            <Box>
            <SheetHeader
                    station={state.station}
                    sheetName={'Treatment'}
                    setSheetValues={setTreatmentValues}
                    sheetDate={treatmentValues.CreateDate === undefined ? convertDateToDisplayformat(new Date()) : convertDateToDisplayformat(treatmentValues.CreateDate)}
                    editMode={editMode} // true for existing evaluation and false only for new evaluation
                    isStation={true}
                />
            </Box>

            {/* Treatment Sheet */}
            <Box>
                {!valuesLoaded ? (
                    <Box align="center" pad="small" gap="small" round="full" margin={{vertical: "large"}}>
                        <Spinner size="medium" /> <Text>Loading...</Text>
                    </Box>
                ) : (
                    <>
                        {showWarning && (
                            <WarningPopupWindow msg={warningMessage} close={onClose} />
                        )}
                        {showError && (
                            <Notification
                                status="critical"
                                message={`ERROR SAVING TREATMENT.`}
                                onClose={() => setShowError(false)}
                            />
                        )}
                        {success && (
                            <Notification
                                status="normal"
                                message={`${sheetName} SHEET SAVED SUCCESSFULLY.`}
                                onClose={() => {
                                    setSuccess(false);
                                    if(navigateAfterSuccess) // <-- trigger navigation here
                                        navigateToEvalSheet(true); 
                                }}
                            />
                        )}      
                        {valuesLoaded && (
                            <TreatmentDetails
                                treatmentValues={treatmentValues}
                                setTreatmentValues={setTreatmentValues}
                                saveTreatmentHandler={saveTreatmentHandler}
                                treatmentValValues={treatmentValValues}
                                setTreatmentValValues={setTreatmentValValues}
                                selectedStation={state.station}
                                phenologicalPhasesDates={state.phenologicalPhasesDates}
                                cultivarData={state.cultivarData}
                                setWarningMessage={setWarningMessage}
                                setShowWarning={setShowWarning}
                                setSuccess={setSuccess}
                                setNavigateAfterSuccess={setNavigateAfterSuccess}
                                setShowError={setShowError}
                                editMode={editMode}
                                hasEdit={hasEdit}
                                disable={disable}
                                newTreatment={newTreatment.current}
                                templatesComboList={templatesComboList}
                                selectedTemplate={selectedTemplate}
                                onChangeSelected={onChangeSelected}
                            />
                        )}
                    </>
                )}
            </Box>
        </Box>
    );



};

export default TreatmentPage;
